import { Link, useNavigate } from "react-router-dom";

import { Space, Breadcrumb, Card } from "antd";
import { PageHeader } from "@ant-design/pro-layout";

import {
  DeviceProfile, 
} from "../../model/model";

import DeviceProfileForm from "./DeviceProfileForm";
import SessionStore from "../../model/SessionStore";


function CreateDeviceProfile() {
  const navigate = useNavigate();

  const onFinish = (obj: DeviceProfile) => {
    SessionStore.getClient().createDeviceProfile(obj, SessionStore.getBearer()).then(() => {
      navigate(`/device-profiles`);
    });
  };

  
  const deviceProfile: DeviceProfile = {
    id: '',
    name: '',
    ioId: '',
    vendor: '',
    version: '',
    configView: '',
    decoder: '',
    decoderConf: '',
    config: '',
    coilsCount: 0,
  };


  return (
    <Space direction="vertical" style={{ width: "100%" }} size="large">
      <PageHeader
        breadcrumbRender={() => (
          <Breadcrumb>
            <Breadcrumb.Item>
              <span>
                <Link to={`/device-profiles`}>Device profiles</Link>
              </span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>Add</span>
            </Breadcrumb.Item>
          </Breadcrumb>
        )}
        title="Add deviceData profile"
      />
      <Card>
        <DeviceProfileForm initialValues={deviceProfile} onFinish={onFinish} />
      </Card>
    </Space>
  );
}

export default CreateDeviceProfile;
